import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import FilterMint from "../filters/FilterMint.vue";
import FilterAmount from "../filters/FilterAmount.vue";
import FilterLinkSignal from "../filters/FilterLinkSignal.vue";

// props
interface IProps {
	data?: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionSwap',
  props: {
    data: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	data?: any;
};



// computed
const FilterSourceMintRef = ref<InstanceType<typeof FilterMint> | null>(null);
const FilterDestinationMintRef = ref<InstanceType<typeof FilterMint> | null>(
	null
);
const FilterAmountRef = ref<InstanceType<typeof FilterAmount> | null>(null);
const isInvalid = computed<boolean>(
	() =>
		FilterSourceMintRef.value?.isInvalid ||
		FilterDestinationMintRef.value?.isInvalid ||
		FilterAmountRef.value?.isInvalid
);
const getData = computed<any>(() => {
	return {
		mint: srcMint.value,
		src_mint: srcMint.value,
		dst_mint: dstMint.value,
		amount: amount.value,
	};
});

// data
const srcMint = ref<string>(props.data?.src_mint ?? "So11111111111111111111111111111111111111112");
const dstMint = ref<string>(props.data?.dst_mint ?? "");
const amount = ref<number>(props.data?.amount ?? 0);

// expose
expose({ isInvalid, data: getData });

return { __sfc: true,props, FilterSourceMintRef, FilterDestinationMintRef, FilterAmountRef, isInvalid, getData, srcMint, dstMint, amount, FilterMint, FilterAmount, FilterLinkSignal }
}

})